module.exports = __webpack_public_path__ + "static/images/allocating.2XCW3s0.svg";